// src/js-dot/core/route/to-sort-string.ts
function toSortString(sortObject) {
  const sortString = [];
  for (let target in sortObject) {
    if (!sortObject.hasOwnProperty(target)) {
      continue;
    }
    const sort = sortObject[target];
    if (typeof sort === "boolean") {
      sortString[sortString.length] = sort ? target : "!" + target;
    }
  }
  return sortString.join(",");
}

// src/js-dot/core/route/from-sort-string.ts
function fromSortString(sortString) {
  if (!sortString) {
    return {};
  }
  const object = {};
  const sorts = sortString.split(",");
  const end = sorts.length;
  let current = -1;
  while (++current < end) {
    const sort = sorts[current];
    if (sort.startsWith("!")) {
      object[sort.substring(1)] = false;
    } else {
      object[sort] = true;
    }
  }
  return object;
}

// src/js-dot/core/route/update-sort-object.ts
function updateSortObject(sortObject, target, descend) {
  if (!sortObject) {
    sortObject = {};
  }
  if (descend) {
    if (sortObject[target] === false) {
      delete sortObject[target];
    } else {
      sortObject[target] = false;
    }
  } else {
    if (sortObject[target] === true) {
      delete sortObject[target];
    } else {
      sortObject[target] = true;
    }
  }
  return sortObject;
}
export { fromSortString, toSortString, updateSortObject };
